__turbopack_context__.v({
  "contentWrapper": "r6Jvuq_contentWrapper",
  "desktopContent": "r6Jvuq_desktopContent",
  "tabletContent": "r6Jvuq_tabletContent",
  "wrapper": "r6Jvuq_wrapper",
});
